/* global CertificadoUtil, BryAdapterFactory */

/**
 * Classe responsável por realizar a autenticação por certificado digital.
 * 
 * @type {Assinatura}
 */
class LoginCertificadoDigital {

    /**
     * Método construtor da classe.
     * 
     * @return {Assinatura}
     */
    constructor() {
        this.listaCertificadosElement = document.getElementById('lista_certificados');
        this.submitElement = document.getElementById('submit_entrar_usando_certificado_digital');

        if (this.submitElement !== null) {
            this.submitElement.addEventListener('click', this.login.bind(this));
        }

        this.bryAdapter = BryAdapterFactory.getInstance();

        this.listCertificadosDisponiveis = new Map();

        this.populateComboCertificates();
    }

    /**
     * Método responsável por popular o combo com os certificados.
     * 
     * @return {void}
     */
    async populateComboCertificates() {
        this.listCertificadosDisponiveis = await this.bryAdapter.getCertificates();
        if (this.submitElement !== null) {

            if (this.listCertificadosDisponiveis.size === 0) {
                this.submitElement.disabled = true;
                this.submitElement.classList.add('btn-disabled');
                this.listaCertificadosElement.disabled = true;
            }

            CertificadoUtil.populateCertificados(this.listaCertificadosElement, this.listCertificadosDisponiveis);
        }
    }

    /**
     * Método responsável por efetuar o login.
     * 
     * @return {void}
     */
    async login() {
        if (this.listaCertificadosElement.value === '') {
            alert('Selecione um certificado da lista.');
            return;
        }

        headers = new Headers();
        headers.append("X-Requested-With", "XMLHttpRequest");
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'text/plain');
        headers.append('Accept', 'application/json');

        let result = await fetch('/authusuariosyscertificadodigital/api', {
            method: 'POST',
            body: JSON.stringify(this.listCertificadosDisponiveis.get(this.listaCertificadosElement.value)),
            headers: headers,
            credentials: "same-origin"
        });

        let data = await result.json();

        if (data.success) {
            window.location = "/conta/configure";
        } else {
            let messagesErrorAuthCertificadoDidigital = document.getElementById('messages_error_auth_certificado_digital');

            if (messagesErrorAuthCertificadoDidigital) {
                messagesErrorAuthCertificadoDidigital.value = data.message;
                messagesErrorAuthCertificadoDidigital.classList.remove('hide');
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if ('BryAdapterFactory' in window) {
        new LoginCertificadoDigital();
    }
});